// extracted by mini-css-extract-plugin
module.exports = {"Legend":"Legend_Legend__tQ3OG","Container":"Legend_Container__SJdFN","Toggle":"Legend_Toggle__1amI2"};